<template>
  <div class="filter">
    <div class="filterContainer">
      <div class="mr10">
        <span class="w120 tar title">标题：</span>
        <a-input
          v-model:value="postParams.title"
          style="width: 220px;"
          placeholder="请输入标题"
          @change="
            e => inputLengthCut({ val: e.target.value, key: 'title', len: 255 })
          "
        />
      </div>
      <div class="mr10">
        <span class="w80 tar title">SEO：</span>
        <a-input
          v-model:value="postParams.seoUrl"
          style="width: 220px;"
          placeholder="请输入SEO"
          @change="
            e =>
              inputLengthCut({ val: e.target.value, key: 'seoUrl', len: 255 })
          "
        />
      </div>
      <div class="mr10">
        <span class="w80 tar title">编码：</span>
        <a-input
          v-model:value="postParams.colId"
          style="width: 220px;"
          placeholder="请输入编码"
          @change="
            e => inputLengthCut({ val: e.target.value, key: 'colId', len: 255 })
          "
        />
      </div>
    </div>
    <div class="filterContainer">
      <div class="mr10">
        <span class="w120 tar title">Shopfiy对应ID：</span>
        <a-input
          v-model:value="postParams.shopifyCollectionId"
          style="width: 220px;"
          placeholder="请输入Shopfiy对应ID"
          @change="
            e =>
              inputLengthCut({
                val: e.target.value,
                key: 'shopifyCollectionId',
                len: 20
              })
          "
        />
      </div>
      <div class="mr10">
        <span class="w80 tar title">同步时间：</span>
        <a-range-picker
          style="width: 220px;"
          @change="e => changeFilterTime(e)"
          v-model:value="postParams.timeSet"
          :placeholder="['开始时间', '结束时间']"
        />
      </div>
      <div class="mr10" v-if="open">
        <span class="w80 tar title">同步人：</span>
        <a-input
          v-model:value="postParams.creatorName"
          style="width: 220px;"
          placeholder="请输入同步人"
          @change="
            e =>
              inputLengthCut({
                val: e.target.value,
                key: 'creatorName',
                len: 50
              })
          "
        />
      </div>
      <div class="mr10 tar" style="width: 320px;" v-if="!open">
        <a-button class="mr10" @click="() => resetParams()">重置</a-button>
        <a-button type="primary" @click="() => initList()">查询</a-button>
        <a-button type="link" @click="open = true"
          ><DownOutlined />展开</a-button
        >
      </div>
    </div>
    <div class="filterContainer" v-if="open">
      <div
        class="mr10 tar"
        style="width: 360px; margin-left: 620px;"
        v-if="open"
      >
        <a-button class="mr10" @click="() => resetParams()">重置</a-button>
        <a-button type="primary" @click="() => initList()">查询</a-button>
        <a-button type="link" @click="open = false"
          ><UpOutlined />收起</a-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { inject, toRefs, reactive } from 'vue'
import { UpOutlined, DownOutlined } from '@ant-design/icons-vue'
export default {
  components: {
    UpOutlined,
    DownOutlined
  },
  setup() {
    const state = reactive({
      open: true
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.filter {
  background: #ffffff;
}

.filterContainer {
  display: flex;
  flex-direction: row;
}

.filter .title {
  display: inline-block;
}
</style>
